import React from 'react';
import SlotManagement from './SlotManagement';

const Holidays = () => {
  return <SlotManagement filter="holidays" />;
};

export default Holidays;
